import AbstractApiService from 'src/services/abstractApiService';
import { api } from 'pages/APIs';
import { dynamicObj } from 'pages/assets';

export default class DocStatusNotificationsApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async getAll(): Promise<any> {
    return super.get(api.get_document_status_alerts);
  }

  public async createOrUpdate(data: any): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, String(value));
    }

    if (data.hasOwnProperty('id')) {
      return super.post(api.update_document_status_alert, formData);
    }

    return super.post(api.create_document_status_alert, formData);
  }

  public async delete(id: string): Promise<any> {
    const formData = new FormData();
    formData.append('id', id);
    return super.delete(api.remove_document_status_alert, formData);
  }

  public async getDocumentAlertStatuses(): Promise<any> {
    return super.get(api.get_document_status_alert_statuses);
  }

  public async activeDocumentAlertStatus(data: any): Promise<any> {
    return super.post(api.toggle_document_status_alert, data);
  }

  public async getStatusAlertLogsByDocAlertId(
    id: string,
    data = {} as dynamicObj,
  ): Promise<any> {
    const querystring = this.encodeQueryData(data);
    return super.get(
      api.get_document_status_alert_logs + id + '?' + querystring,
    );
  }
}
